import { useQuery } from "@tanstack/react-query";

import {
  getProjects,
  type ProjectState,
  type SortableColumn,
  type SortOrder,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "./queryKeys";

export interface ProjectsListQueryParams {
  offset?: number;
  limit?: number;
  clientID?: string | null;
  searchQuery?: string | null;
  projectState?: ProjectState | null;
  sortBy?: SortableColumn;
  sortOrder?: SortOrder;
}

export function useProjectsListQuery(params: ProjectsListQueryParams) {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEYS.list(params),
    queryFn: processResponse(() =>
      getProjects(
        params.offset,
        params.limit,
        params.clientID,
        params.projectState,
        params.searchQuery,
        params.sortBy,
        params.sortOrder,
      ),
    ),
  });
}
